import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CepForm from 'components/CepForm/CepForm';
import Heading from 'components/Heading';
import MayaLayout from 'components/MayaLayout';
import useCepCreate from 'routes/AuthenticatedApp/CepCreate/CepCreate.hook';

const CepCreate: FC = () => {
  const { t } = useTranslation();
  const {
    submitCallback,
  } = useCepCreate();

  return (
    <MayaLayout>
      <Heading>
        { t('maya_create_cep_form_title') }
      </Heading>

      <CepForm submitCallback={ submitCallback } isTemplate={ false } />
    </MayaLayout>
  );
};

export default CepCreate;
